import { HttpErrorResponse } from '@angular/common/http';
import { match, P } from 'ts-pattern';

export interface PSErrorOptions {
  customMessage: string;
  context: string;
  metadata: Record<string, unknown>;
}

export class PSError extends Error {
  private constructor(
    public readonly source: Error,
    public readonly info = '',
    public readonly metadata: Record<string, unknown> = {},
  ) {
    super(source.message);
  }

  public static http(
    error: HttpErrorResponse,
    options: Partial<PSErrorOptions> = {
      context: '',
      metadata: {},
    },
  ): PSError {
    const message = match<unknown>(error)
      .with({ error: P.instanceOf(ErrorEvent) }, (e) => e.error.message)
      .with({ error: { error: P.string } }, (e) => e.error.error)
      .with({ error: { message: P.string } }, (e) => e.error.message)
      .with({ error: { msg: P.string } }, (e) => e.error.msg)
      .with({ error: P.string.select() }, (str) =>
        str.length > 0 ? str : 'Unknown Error',
      )
      .with({ message: P.string }, (e) => e.message)
      .otherwise(() => 'An unexpected error occurred');

    const _metadata = {
      reason: error.message,
      http: error,
      notify: true,
      ...options.metadata,
    };

    return PSError.from(message, options.context, _metadata);
  }

  public static from(
    message: string,
    context = '',
    metadata: Record<string, unknown> = {},
  ): PSError {
    return new PSError(new Error(message), context, metadata);
  }

  public context(
    message: string,
    metadata: Record<string, unknown> = {},
  ): PSError {
    return new PSError(this.source, message, metadata);
  }

  public print(): void {
    const css = 'background: red; padding: 3px ; color: white';
    console.log('%c[Error Context]:', css, this.info);
    console.log('%c[Error Message]:', css, this.message);
    console.log('%c[Error Metadata]:', css, this.metadata);
    console.error(this);
  }
}
